import React from "react";
import {
    Typography,
    Card,
    CardContent,
    CardHeader,
    Box,
    Stack,
} from "@mui/material";

import DayJS from "react-dayjs";
import ListItemMenu from "../../../Common/ListItemMenu";
import PORTAvatar from "../PORTAvatar";
import LinkButton from "../../../Common/Button/LinkButton";

function NoteCard({ note, onDelete, onEdit }) {
    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={<PORTAvatar type={"note"} />}
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        <ListItemMenu
                            onDelete={!!note?.canDelete && onDelete}
                            onEdit={note?.canUpdate && onEdit}
                        />
                        <LinkButton to={`/portfolio/notes/${note.id}`} />
                    </Stack>
                }
                title={
                    <Typography component="h3" className="card-header-title">
                        {note.title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        <DayJS format="DD MMM YYYY">{note.createdAt}</DayJS>
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <Typography variant="body1">{note.description}</Typography>
                </Box>
            </CardContent>
        </Card>
    );
}

export default NoteCard;
